import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./About.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import RookTech from "../../images/rook-no-bg.png";

const About = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.pageWrapper}>
      <Navbar />
      <main className={styles.aboutMain}>
        <img
          className={styles.towerBackground}
          src={RookTech}
          alt="Rook Tech Background"
        />

        <section className={styles.aboutTextBlock}>
          <h2 className={styles.aboutTitle}>{t("about.title")}</h2>
          <p className={styles.aboutHighlight}>{t("about.welcome")}</p>
          <p className={styles.aboutSubtitle}>{t("about.highlight")}</p>

          <div className={styles.aboutDescription}>
            <p>{t("about.p1")}</p>
            <p>{t("about.p2")}</p>
            <p>{t("about.p3")}</p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default About;
